import { render, staticRenderFns } from "./LatestNewsWidget.vue?vue&type=template&id=2e722184&"
import script from "./LatestNewsWidget.vue?vue&type=script&lang=js&"
export * from "./LatestNewsWidget.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsWidget.vue?vue&type=style&index=0&id=2e722184&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports